/* tslint:disable */
/* eslint-disable */
/**
 * Document Simulation API
 * API for managing document simulations and contractualization strategies
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Manual verification of identity names entered by the user when OCR fails or mismatches.
 * @export
 * @interface IdentityVerifyCommand
 */
export interface IdentityVerifyCommand {
    /**
     * Identifier of the previously uploaded identity document.
     * @type {string}
     * @memberof IdentityVerifyCommand
     */
    storedFileId: string;
    /**
     * Identifier of the person being verified.
     * @type {string}
     * @memberof IdentityVerifyCommand
     */
    naturalPersonId: string;
    /**
     * First name typed by the user.
     * @type {string}
     * @memberof IdentityVerifyCommand
     */
    firstName: string;
    /**
     * Last name typed by the user.
     * @type {string}
     * @memberof IdentityVerifyCommand
     */
    lastName: string;
}

/**
 * Check if a given object implements the IdentityVerifyCommand interface.
 */
export function instanceOfIdentityVerifyCommand(value: object): value is IdentityVerifyCommand {
    if (!('storedFileId' in value) || value['storedFileId'] === undefined) return false;
    if (!('naturalPersonId' in value) || value['naturalPersonId'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    return true;
}

export function IdentityVerifyCommandFromJSON(json: any): IdentityVerifyCommand {
    return IdentityVerifyCommandFromJSONTyped(json, false);
}

export function IdentityVerifyCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): IdentityVerifyCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'storedFileId': json['storedFileId'],
        'naturalPersonId': json['naturalPersonId'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
    };
}

export function IdentityVerifyCommandToJSON(json: any): IdentityVerifyCommand {
    return IdentityVerifyCommandToJSONTyped(json, false);
}

export function IdentityVerifyCommandToJSONTyped(value?: IdentityVerifyCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'storedFileId': value['storedFileId'],
        'naturalPersonId': value['naturalPersonId'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
    };
}

